import React, { Component } from "react";
import _ from 'lodash';

import TreeView from "@zippytech/react-toolkit/TreeView";
import "@zippytech/react-toolkit/TreeView/index.css";
import MenuNode from "./MenuNode";
import { dispatch } from "@rematch/core";

class PracticeFlowTreePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateTime: new Date(),

    };
  }

  onSelectionChange(selectedMap) {
    if (_.has(selectedMap, "node.label.props.id")) {
      dispatch.initiatives.showResourecePane("Communities");
      dispatch.initiatives.splitAt("60%");
      dispatch.initiatives.setSuborganizationData({})
      dispatch.initiatives.getSelectedCommunityAsync(selectedMap.node.label.props.id);
      dispatch.initiatives.setIdToCenterPosition(selectedMap.node.label.props.id);
    }
    return;
  }



  render() {
    let length = this.props.selectedDataById.communities.filter((node) => { return !node.isLeafNode }).length;
    let treeLabelWithColor;
    let components = [];
    const thisObject = this;
    const getDataNode = function (treeData, container, depth) {
      treeData.forEach(function (treeNode) {
        treeLabelWithColor = <span>{treeNode.parentCommunity ? <span> <span className="colorTag" style={{ 'background': treeNode.tagColor }}></span> {treeNode.name}  </span> : <span> {treeNode.name} </span>}</span>
        if (!treeNode.isLeafNode) {
          const dataNode = {
            label: (
              <MenuNode
                label={treeNode.name}
                colorTag={treeNode.tagColor}
                id={treeNode._id}
                depth={depth}
                treeLength={length}
                parentCommunity={treeNode.parentCommunity}
                disabled={true}
                status={thisObject.props.selectedDataById.status}
                associatedTeam={treeNode.associatedTeam}
                setUniqueId={thisObject.props.setUniqueId}
                isRaciUpdated={treeNode.isRaciUpdated}
              />
            ),
            raci: treeNode.raci
          };
          if (treeNode.communities && treeNode.communities.length && depth < 1) {
            dataNode.nodes = [];


            getDataNode(treeNode.communities, dataNode.nodes, depth + 1);
          }

          container.push(dataNode);
        }
      });
    };

    getDataNode(this.props.selectedDataById.communities, components, 0);
    let windowDimension = this.props.componentDesignerDimension;
    let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 280;
    return (
      <div style={{ maxHeight: designerHeight, overflow: "auto" }}>
        <TreeView
          className={`designerTree `}

          dataSource={components}
          enableSelection={true}
          enableHoverStyle={false}
          singleSelect={true}
          enableScrollNodeIntoView={false}
          onSelectionChange={(selectedMap) => {
            this.onSelectionChange(selectedMap);
          }}

          enableKeyboardNavigation={false}

        />
      </div>
    );
  }
}

export default PracticeFlowTreePage;
